import { Table } from "antd";
import { useTranslation } from "react-i18next";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { displayDate } from "utils/helpers/date";

function List({ data, count, setValues, skip }) {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.NOTIFICATION);
  const LIST = t("LIST", { returnObjects: true });
  const columns = [
    {
      title: LIST.DATE,
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date) => displayDate({ date }),
    },
    {
      title: LIST.CONTENT,
      dataIndex: "content",
      key: "content",
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <br />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
